import React, { useEffect } from 'react'
import { MechanicalTemplate } from '../../templates'
// import { ScrollTop } from '../../molecules' // uncomment if you have this shared component

export function MechanicalDesign() {
    useEffect(() => {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    }, [])
    return (
        <div>
            {/* <ScrollTop /> */}
            <MechanicalTemplate />
        </div>
    )
}
